import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { GrnItemsEntity } from "./grn-items-entity";

@Entity('roll_wise_stock')
export class RollWiseStockEntity {
  @PrimaryGeneratedColumn('increment', {
    name: 'roll_id'
  })
  rollId: number
  
  @Column('varchar', {
    name: 'roll_no',
    nullable: false
  })
  rollNo: string

  @Column('decimal', {
    name: 'received_qty',
    nullable: false
})
receivedQty: number

@Column('decimal', {
    name: 'accepted_qty',
    nullable: false
})
acceptedQty: number

@Column('varchar', {
    name: 'remarks',
    nullable: true
  })
  remarks: string

  @Column('int', {
    name: 'grn_item_id',
    nullable: false
  })
  grnItemId: number

  @CreateDateColumn({
    name: "created_at",
  })
  createdAt: string;

  @Column("varchar", {
    nullable: true,
    length: 40,
    name: "created_user",
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
  })
  updatedAt: string;

  @Column("varchar", {
    nullable: true,
    length: 40,
    name: "updated_user",
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag",
  })
  versionFlag: number;

  
  @ManyToOne(type => GrnItemsEntity, grn => grn.rollWiseStockInfo)
    @JoinColumn({ name: 'grn_item_id' })
    grnItemEntity: GrnItemsEntity;
}
